import React, { useState } from "react";
import emailjs from '@emailjs/browser';
import "../styles/Contact.css";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // EmailJS configuration - Replace with your actual values
    const serviceId = 'your_service_id';
    const templateId = 'your_template_id';
    const publicKey = 'your_public_key';

    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      message: formData.message,
      to_email: 'connect@arocl.com' // Replace with your email
    };

    emailjs.send(serviceId, templateId, templateParams, publicKey)
      .then((response) => {
        console.log('Email sent successfully!', response.status, response.text);
        alert('Message sent successfully!');
        setFormData({ name: '', email: '', message: '' });
      })
      .catch((error) => {
        console.error('Failed to send email:', error);
        alert('Failed to send message. Please try again.');
      });
  };

  return (
    <section id="contact" className="contact">
      <h2>Contact Us</h2>

      {/* Address Section */}
      <div className="contact-address">
        <p>
          <strong>Office Address:</strong><br />
          Office No 271, Plot No. 20, Satra Plaza,<br />
          Sector 19D, Vashi, Navi Mumbai,<br />
          Thane - 400705, Maharashtra.
        </p>
        {/* Google Maps Link */}
        <p>
          <a 
            href="https://www.google.com/maps/search/?api=1&query=Office+No+271,+Plot+No+20,+Satra+Plaza,+Sector+19D,+Vashi,+Navi+Mumbai,+Thane+400705,+Maharashtra" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            📍 View on Google Maps
          </a>
        </p>
        {/* Click-to-call phone number */}
        <p>
          <a href="tel:+9196191 01155">📞 +91 96191 01155</a>
          {'  '}
          <a href="tel:+9170183 16669">📞 +91 70183 16669</a>
        </p>
      </div>

      {/* Contact Form */}
      <form className="contact-form" onSubmit={handleSubmit}>
        <input 
          type="text" 
          name="name"
          placeholder="Your Name" 
          value={formData.name}
          onChange={handleChange}
          required 
        />
        <input 
          type="email" 
          name="email"
          placeholder="Your Email" 
          value={formData.email}
          onChange={handleChange}
          required 
        />
        <textarea 
          name="message"
          placeholder="Message"
          value={formData.message}
          onChange={handleChange}
        ></textarea>
        <button type="submit">Send</button>
      </form>
    </section>
  );
}
